import {IFilterPanel} from '../filterPanel/types';

export const getCurrentEditingFilterIdSelector = (
    state: IFilterPanel
): number => {
    return state.editedFilter && state.editedFilter.id ? state.editedFilter.id : state.defaultFilter.id;
};
